<template>
  <div>
    <el-form
      v-model="placementMsg"
      label-width="120px"
    >
      <el-form-item label="版位：">
        <el-radio-group v-model="placementType">
          <el-radio :label="1">进阶版位</el-radio>
          <el-radio :label="2">选择版位</el-radio>
        </el-radio-group>
      </el-form-item>
      <span v-if="placementType == 2">
        <el-form-item label="设备类型：">
          <el-select
            v-model="placementMsg.device_platforms"
            placeholder="请选择"
            multiple
            @change="selectPlacement"
          >
            <el-option
              :label="item.desc"
              :value="item.key"
              v-for="item in platForm"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div>
            <div class="tree">
              <el-tree
                :data="platFormList.filter((v) => v.key == treeItem.key)"
                show-checkbox
                default-expand-all
                node-key="key"
                :props="defaultProps"
                :default-checked-keys="checkedNodes[treeItem.key + '_positions']"
                v-for="treeItem in platFormList"
                :key="treeItem.key"
                ref="plateTree"
                @check="checkChange"
              >
              </el-tree>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="移动设备："
          v-if="placementMsg.device_platforms.includes('mobile')"
        >
          <el-select
            v-model="placementMsg.user_os"
            placeholder="请选择"
            @change="selectDevice"
          >
            <el-option
              :label="item.desc"
              :value="item.key"
              v-for="item in userOsList"
              :key="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="设备机型"> -->
        <span v-if="placementMsg.device_platforms.includes('mobile') && placementMsg.user_os != 'All'">
          <selectTag
            :data="placementList"
            :params="{ id: 'id', name: 'description', children: 'childList' }"
            keys="model"
            label="设备机型："
            place="请选择设备机型"
            :list="placementMsg.user_device"
            :listDefault="placementMsg.user_device"
            @setList="setList"
          ></selectTag>
        </span>

        <!-- </el-form-item> -->
      </span>
    </el-form>
    <!-- <div class="topPreviw">
                <div class="top-radio">
                    <el-radio v-model="radio" label="1" >自动版位</el-radio>
                    <el-radio v-model="radio" label="2" >选择版位</el-radio>
                </div>
                <div v-if="radio == 2">
                    <el-select v-model="device_platforms" placeholder="" @change="selectPlacement" multiple>
                        <el-option :label="item.desc" :value="item.key"  v-for="(item) in initData.placement.DevicePlatform" :key="item.key"></el-option>
                    </el-select>
                    <div class="tree" v-if="initData.placement">
                        <el-tree
                        :data="platFormList.filter(v=>v.key == treeItem.key)"
                        show-checkbox
                        default-expand-all
                        node-key="key"
                        :props="defaultProps"
                        :default-checked-keys="checkedNodes[treeItem.key+'_positions']"
                        v-for="treeItem in platFormList" :key="treeItem.key"
                        ref="plateTree">
                        </el-tree>
                    </div>
                </div>
            </div> -->
  </div>
</template>
<script>
const placementListAll = require('@/assets/json/placement.json');
import selectTag from './selectTag.vue';
export default {
  props: {
    placement: {
      type: Object,
      default: () => {},
    },
    initData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    selectTag,
  },
  data() {
    return {
      device_platforms: [],
      defaultProps: {
        children: 'positions',
        label: 'desc',
      },
    };
  },
  computed: {
    placementType: {
      get() {
        if (this.placement.device_platforms && this.placement.device_platforms.length) {
          return 2;
        } else {
          return 1;
        }
      },
      set(v) {
        this.selectType(v);
      },
    },
    placementList: {
      get() {
        if (this.placementMsg.user_os == 'iOS') {
          return placementListAll.filter((v) => v.platform == '2');
        } else if (this.placementMsg.user_os == 'Android') {
          return placementListAll.filter((v) => v.platform == '1');
        } else {
          return placementListAll.filter((v) => v.platform !== '3');
        }
      },
    },
    listDefault: {
      get() {
        console.log(this.placementMsg.user_os);
        if (this.placementMsg.user_os == 'iOS') {
          this.placementMsg.user_device =
            this.placementMsg.user_device || placementListAll.filter((v) => v.platform == '2').map((v) => v.id);
        } else if (this.placementMsg.user_os == 'Android') {
          this.placementMsg.user_device =
            this.placementMsg.user_device || placementListAll.filter((v) => v.platform == '1').map((v) => v.id);
        } else {
          this.placementMsg.user_device =
            this.placementMsg.user_device || placementListAll.filter((v) => v.platform !== '3').map((v) => v.id);
        }
        return this.placementMsg.user_device;
      },
    },
    userOsList: {
      get() {
        let list = [];
        this.placementMsg.device_platforms.map((key) => {
          list = list.concat(this.platForm.filter((v) => v.key == key)[0].userOsList || []);
        });
        return list;
      },
    },
    checkedNodes: {
      get() {
        const obj = {};
        const platforms = this.initData?.placement?.PublisherPlatform || [];
        platforms.forEach((p) => {
          const k = p.key + '_positions';
          obj[k] = this.placement[k] || [];
        });
        return obj;
      },
      set() {},
    },
    placementMsg: {
      get() {
        if (this.placement && Object.keys(this.placement).length) {
          // 处理 user_os：确保转换为字符串用于 UI 显示
          if (this.placement.user_os && Array.isArray(this.placement.user_os) && this.placement.user_os.length) {
            // 如果是数组，取第一个元素
            this.placement.user_os = this.placement.user_os[0];
          } else if (!this.placement.user_os) {
            // 如果为空，设置默认值
            this.placement.user_os = 'All';
          }
          // 如果已经是字符串，保持不变

          return this.placement;
        } else {
          return {
            device_platforms: [],
          };
        }
      },
      set() {},
    },
    platForm: {
      get() {
        return this.initData?.placement.DevicePlatform || [];
      },
    },
    platFormList: {
      get() {
        let data = JSON.parse(JSON.stringify(this.initData.placement.PublisherPlatform));
        if (!this.placementMsg.device_platforms || !this.placementMsg.device_platforms.length) {
          data.map((key, i) => {
            key.disabled = true;
            key.positions.map((item, m) => {
              item.disabled = true;
              this.$set(key.positions, m, item);
            });
          });
          return data;
        }
        console.log(this.checkedNodes.facebook_positions);
        let list = Object.keys(this.checkedNodes).reduce((acc, k) => acc.concat(this.checkedNodes[k] || []), []);
        let list1 = Object.keys(this.checkedNodes).map((k) => this.checkedNodes[k] || []);
        let key1 = '';
        console.log(list1);
        if (list1.filter((v) => v.length).length == 1) {
          const onlyKey = Object.keys(this.checkedNodes).find((k) => (this.checkedNodes[k] || []).length);
          key1 = onlyKey ? onlyKey.replace(/_positions$/, '') : '';
        }
        console.log(key1);
        data.map((key, i) => {
          console.log(key);
          if (key.key == key1) {
            key.disabled = true;
          } else {
            key.disabled = false;
          }
        });
        if (list.length == 1) {
          data.map((key, i) => {
            console.log(key);
            if (key.key == key1) {
              key.disabled = true;
            } else {
              key.disabled = false;
            }
            key.positions.map((item, m) => {
              if (item.key == list[0]) {
                console.log(item.key + '=' + list[0].key);
                item.disabled = true;
              } else {
                item.disabled = false;
              }
              this.$set(key.positions, m, item);
            });
            this.$set(data, i, key);
          });
          return data;
        }
        data.map((key, i) => {
          key.positions.map((item, m) => {
            if (item.devicePlatforms.some((v) => this.placementMsg.device_platforms.some((m) => v.key == m))) {
              item.disabled = false;
            } else {
              item.disabled = true;
            }
            this.$set(key.positions, m, item);
          });
          this.$set(data, i, key);
        });
        return data;
      },
    },
    set() {},
  },
  methods: {
    checkChange(a, b, c) {
      this.$nextTick(() => {
        this.emitPlacement();
      });
    },
    // 选择设备
    selectPlacement(val) {
      let data = JSON.parse(JSON.stringify(this.initData.placement.PublisherPlatform));
      data.map((key, i) => {
        key.positions.map((item, m) => {
          if (item.devicePlatforms.some((v) => val.some((m) => v.key == m))) {
            item.disabled = false;
            // 确保 placement 对象中有对应的 positions 数组
            const positionKey = key.key + '_positions';
            if (!this.placement[positionKey]) {
              this.$set(this.placement, positionKey, []);
            }
            // 避免重复添加
            if (!this.placement[positionKey].includes(item.key)) {
              this.placement[positionKey].push(item.key);
            }
          } else {
            item.disabled = true;
          }
          this.$set(key.positions, m, item);
        });
        this.$set(data, i, key);
      });
      if (!val.includes('mobile')) {
        this.user_os = 'All';
        this.user_device = [];
      }
      this.emitPlacement();
    },
    // 选择是否是自动版位
    selectType(v) {
      if (v == 1) {
        // 切换到进阶版位时，清空所有已选择的版位数据，恢复初始值
        // 直接操作 placement 对象（props传入的原始对象）
        this.$set(this.placement, 'device_platforms', []);
        this.$set(this.placement, 'publisher_platforms', []);
        this.$set(this.placement, 'user_os', ['All']);
        this.$set(this.placement, 'user_device', []);
        const clearedPositions = this.emptyPositionMap();
        Object.keys(clearedPositions).forEach((k) => {
          this.$set(this.placement, k, []);
        });
        // 清空树组件的选中状态
        if (this.$refs.plateTree) {
          const trees = Array.isArray(this.$refs.plateTree) ? this.$refs.plateTree : [this.$refs.plateTree];
          trees.forEach((tree) => {
            tree.setCheckedKeys([]);
          });
        }
        // 直接 emit 清空后的数据，不调用 getPlateform() 避免被树组件的旧数据覆盖
        const emitData = {
          ...this.placement,
          ...clearedPositions,
          device_platforms: [],
          publisher_platforms: [],
          user_os: ['All'],
          user_device: [],
        };
        this.$nextTick(() => {
          this.$emit('getPlacemment', emitData);
        });
      } else {
        this.placementMsg.device_platforms = ['mobile', 'desktop'];
        this.selectPlacement(this.placementMsg.device_platforms);
      }
    },
    // 选择版位
    checkPlate(a, b, c) {
      console.log(a, b, c);
      // this.checkedNodes
    },
    emptyPositionMap() {
      const palteList = {};
      (this.initData?.placement?.PublisherPlatform || []).forEach((p) => {
        palteList[p.key + '_positions'] = [];
      });
      return palteList;
    },
    // 获取版位信息：按平台 key 收集，避免枚举增删后下标错位（threads / whatsapp）
    getPlateform() {
      const palteList = this.emptyPositionMap();
      const publisher_platforms = [];
      const platforms = this.platFormList || [];
      if (!this.$refs.plateTree) {
        return {
          ...palteList,
          publisher_platforms,
        };
      }
      const trees = Array.isArray(this.$refs.plateTree) ? this.$refs.plateTree : [this.$refs.plateTree];
      trees.forEach((tree, i) => {
        const platform = platforms[i];
        if (!platform || !tree || typeof tree.getCheckedKeys !== 'function') return;
        const checked = (tree.getCheckedKeys() || []).filter((v) => v !== platform.key);
        palteList[platform.key + '_positions'] = checked;
        if (checked.length) {
          publisher_platforms.push(platform.key);
        }
      });
      return {
        ...palteList,
        publisher_platforms,
      };
    },
    setList(v) {
      this.placementMsg.user_device = v;
      this.emitPlacement();
    },
    selectDevice(v) {
      if (v == 'iOS') {
        this.placementMsg.user_device = placementListAll.filter((v) => v.platform == '2').map((v) => v.id);
      } else if (v == 'Android') {
        this.placementMsg.user_device = placementListAll.filter((v) => v.platform == '1').map((v) => v.id);
      } else {
        this.placementMsg.user_device = [];
      }
      this.emitPlacement();
    },
    emitPlacement() {
      // 创建一个新对象，确保 user_os 是数组格式，不修改原始数据
      const emitData = {
        ...this.placementMsg,
        ...this.getPlateform(),
      };
      // 确保 user_os 是数组格式
      if (!Array.isArray(emitData.user_os)) {
        emitData.user_os = [emitData.user_os];
      }
      emitData.user_device = emitData.user_device ? emitData.user_device : [];
      this.$nextTick(() => {
        this.$emit('getPlacemment', emitData);
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
